import {
  DerivedEventTypeLegacy,
  IndexDateVariableLegacy,
  SimpleEventType,
  SimpleEventTypeLegacy,
} from '@verantos-dev/types-cohorts';

import { transformDerivedEventTypeToGrammarValue } from '../adapters/transformDerivedEventTypeToGrammarValue';
import { transformSimpleEventTypeToGrammarSimpleEventType } from '../adapters/transformSimpleEventTypeToGrammarSimpleEventType';

export const getNextIndexDateForEventNameChange = (
  indexDate: IndexDateVariableLegacy | undefined,
  referencedEventName: string,
  newReferencedEventName: string,
  newType: DerivedEventTypeLegacy | SimpleEventTypeLegacy | SimpleEventType | undefined,
  isSimpleEvent = true
): IndexDateVariableLegacy | undefined => {
  if (!indexDate) {
    return undefined;
  }

  // Update indexDateEvent.eventName.value (newer implementation)
  let nextIndexDateEvent = indexDate.indexDateEvent;
  if (indexDate.indexDateEvent) {
    const eventNameValue = indexDate.indexDateEvent.eventName.value;
    const eventNameReferenceEventName = eventNameValue?.split('::')[1];
    if (
      eventNameReferenceEventName?.slice(1, eventNameReferenceEventName.length - 1) ===
      referencedEventName
    ) {
      nextIndexDateEvent = {
        ...indexDate.indexDateEvent,
        eventName: {
          ...indexDate.indexDateEvent.eventName,
          value: `${
            isSimpleEvent
              ? transformSimpleEventTypeToGrammarSimpleEventType(
                  newType as SimpleEventTypeLegacy | SimpleEventType | undefined
                )
              : transformDerivedEventTypeToGrammarValue(
                  newType as DerivedEventTypeLegacy | undefined
                )
          }::"${newReferencedEventName}"`,
        },
      };
    }
  }

  // Update indexDateValue (older implementation)
  let nextIndexDateValue = indexDate.indexDateValue;
  if (indexDate.indexDateValue) {
    const indexDateValueReferenceEventName = indexDate.indexDateValue?.split('::')?.[1];
    if (
      indexDateValueReferenceEventName?.slice(1, indexDateValueReferenceEventName.length - 1) ===
      referencedEventName
    ) {
      nextIndexDateValue = `${
        isSimpleEvent
          ? transformSimpleEventTypeToGrammarSimpleEventType(
              newType as SimpleEventTypeLegacy | SimpleEventType | undefined
            )
          : transformDerivedEventTypeToGrammarValue(newType as DerivedEventTypeLegacy | undefined)
      }::"${newReferencedEventName}"`;
    }
  }

  return {
    ...indexDate,
    indexDateEvent: nextIndexDateEvent,
    indexDateValue: nextIndexDateValue,
  };
};
